"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Content = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Content(props) {
    var _this;
    _classCallCheck(this, Content);
    _this = _callSuper(this, Content, [props]);
    _defineProperty(_this, "setVideoWidth", function () {
      var _this$state = _this.state,
        videoWidth = _this$state.videoWidth,
        videoHeight = _this$state.videoHeight;
      if (_this.videoRef.current) {
        var width = _this.videoRef.current.getBoundingClientRect().width;
        _this.videoRef.current.style.height = "".concat(width * (videoHeight / videoWidth), "px");
      }
    });
    _defineProperty(_this, "renderText", function () {
      // infoBarTextColor for backwards compatibility only - should use wysiwyg instead
      var _this$props = _this.props,
        displayOptions = _this$props.displayOptions,
        text = _this$props.text;
      var styles = displayOptions && displayOptions.portal && displayOptions.portal.infoBarTextColor ? {
        color: displayOptions.portal.infoBarTextColor
      } : {};
      return !!text && /*#__PURE__*/_react["default"].createElement("span", {
        style: styles
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: text
      }));
    });
    _defineProperty(_this, "renderImage", function () {
      return !_this.props.config.backgroundImage && /*#__PURE__*/_react["default"].createElement("img", {
        className: _style["default"].image,
        src: _this.props.image.url,
        alt: "banner"
      });
    });
    _defineProperty(_this, "renderVideo", function () {
      return !!_this.props.video && /*#__PURE__*/_react["default"].createElement("div", {
        ref: _this.videoRef,
        className: _style["default"].videoRef
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: _this.props.video
      }));
    });
    var _videoWidth;
    var _videoHeight;
    try {
      _videoWidth = Number(props.video.match(/width=["']{1}[0-9]{1,4}["']{1}?/)[0].replace(/[^\d]/g, ''));
      _videoHeight = Number(props.video.match(/height=["']{1}[0-9]{1,4}["']{1}?/)[0].replace(/[^\d]/g, ''));
    } catch (e) {
      if (props.video) {
        console.error('Cannot determine width and height on video <iframe>; Assuming 16:9 aspect ratio.');
        _videoWidth = 16;
        _videoHeight = 9;
      }
    }
    _this.state = {
      videoWidth: _videoWidth,
      videoHeight: _videoHeight
    };
    _this.videoRef = /*#__PURE__*/_react["default"].createRef();
    _this.divRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _inherits(Content, _React$Component);
  return _createClass(Content, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.video && ['videoText', 'textVideo'].includes(this.props.layout)) {
        this.setVideoWidth();
        window.addEventListener('resize', this.setVideoWidth);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.video && ['videoText', 'textVideo'].includes(this.props.layout)) {
        window.removeEventListener('resize', this.setVideoWidth);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        image = _this$props2.image,
        config = _this$props2.config,
        layout = _this$props2.layout;
      var leftSide;
      var rightSide;
      switch (layout) {
        case 'textImage':
          leftSide = this.renderText();
          rightSide = this.renderImage();
          break;
        case 'imageText':
          leftSide = this.renderImage();
          rightSide = this.renderText();
          break;
        case 'textVideo':
          leftSide = this.renderText();
          rightSide = this.renderVideo();
          break;
        case 'videoText':
          leftSide = this.renderVideo();
          rightSide = this.renderText();
          break;
        default:
          leftSide = this.renderText();
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].content,
        style: config && config.backgroundImage && (layout === 'textImage' || layout === 'imageText') ? {
          backgroundImage: "url(".concat(image.url, ")"),
          backgroundSize: 'cover',
          backgroundPosition: 'center center'
        } : {},
        ref: this.divRef
      }, leftSide && /*#__PURE__*/_react["default"].createElement("div", null, leftSide), rightSide && /*#__PURE__*/_react["default"].createElement("div", null, rightSide));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Content, "propTypes", {
  config: _propTypes["default"].object,
  displayOptions: _propTypes["default"].object,
  image: _propTypes["default"].object,
  layout: _propTypes["default"].string,
  text: _propTypes["default"].string,
  video: _propTypes["default"].string
});